import * as PropTypes from 'prop-types'
import { StaggeredMotion, spring } from 'react-motion'

import { MOTION_PRESETS } from '/react/constants/motionPresets'

export class StaggeredTextAnimation extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onRestCallback: PropTypes.func,
    startAnimation: PropTypes.bool.isRequired
  }

  springConfig = MOTION_PRESETS.SLOW

  render () {
    const {
      children,
      onRestCallback,
      startAnimation
    } = this.props

    const startStyles = {
      opacity: 0,
      top: 100
    }

    const contentElements = React.Children.toArray(children)
    const defaultStyles = contentElements.map(() => (startStyles))

    return (
      <StaggeredMotion
        defaultStyles={defaultStyles}
        styles={(prevInterpolatedStyles) => prevInterpolatedStyles.map((style, i) => {
          return i === 0
            ? {
              opacity: startAnimation ? spring(1, this.springConfig) : startStyles.opacity,
              top: startAnimation ? spring(0, this.springConfig) : startStyles.top
            }
            : {
              opacity: spring(prevInterpolatedStyles[i - 1].opacity, this.springConfig),
              top: spring(prevInterpolatedStyles[i - 1].top, this.springConfig)
            }
        })}>
        {(interpolatingStyles) => (
          <div>
            {interpolatingStyles.map((style, i) => {
              /*
              Dirty hack because StaggeredMotion does not support the onRest callback.
              See: https://github.com/chenglou/react-motion/issues/440
               */
              if (onRestCallback && i === contentElements.length - 1 && style.top === 0) {
                setTimeout(() => onRestCallback())
              }

              if (!contentElements[i]) return null

              return React.cloneElement(contentElements[i], {
                key: i,
                style: {
                  opacity: style.opacity,
                  transform: `translate3d(0, ${style.top}px, 0)`
                }
              })
            })}
          </div>
        )}
      </StaggeredMotion>
    )
  }
}
